// extracted by mini-css-extract-plugin
export var CasestudyContainer = "analytics-module--CasestudyContainer--23730";
export var CasestudyContainerVertical = "analytics-module--CasestudyContainerVertical--002ea";
export var KpointPlayerModuleVideoContainer9610c = "analytics-module--KpointPlayer-module--videoContainer--9610c--df9da";
export var ReactModal__Overlay = "analytics-module--ReactModal__Overlay--ef0b5";
export var analyticsCasestudy = "analytics-module--analyticsCasestudy--a76b5";
export var analyticsContainer = "analytics-module--analyticsContainer--b48d0";
export var analyticsContainerVertical = "analytics-module--analyticsContainerVertical--b283c";
export var analyticsGraphThumbnail = "analytics-module--analyticsGraphThumbnail--c816c";
export var analyticsGraphThumbnailVertical = "analytics-module--analyticsGraphThumbnailVertical--63827";
export var analyticsThumbnail = "analytics-module--analyticsThumbnail--e6b5f";
export var analyticsThumbnailContainer = "analytics-module--analyticsThumbnailContainer--b9515";
export var analyticsThumbnailVertical = "analytics-module--analyticsThumbnailVertical--4cfca";
export var analyticsTitle = "analytics-module--analyticsTitle--5fa53";
export var casestudyAnalyticsThumbnailNoDiy = "analytics-module--casestudyAnalyticsThumbnailNoDiy--0598f";
export var casestudyDescription = "analytics-module--casestudyDescription--8d7e7";
export var casestudyDescriptionVertical = "analytics-module--casestudyDescriptionVertical--7a158";
export var casestudyDiy = "analytics-module--casestudyDiy--713c7";
export var casestudyDiyContainer = "analytics-module--casestudyDiyContainer--9289b";
export var casestudyDiyContainerVertical = "analytics-module--casestudyDiyContainerVertical--c976e";
export var casestudyDiyVertical = "analytics-module--casestudyDiyVertical--6b705";
export var casestudyNoDiy = "analytics-module--casestudyNoDiy--d1f86";
export var casestudyThumbnailContainer = "analytics-module--casestudyThumbnailContainer--7af0a";
export var casestudyTitle = "analytics-module--casestudyTitle--892a3";
export var casestudyVideoContainer = "analytics-module--casestudyVideoContainer--97fe0";
export var casestudyVideoContainerVertical = "analytics-module--casestudyVideoContainerVertical--5d880";
export var closeButton = "analytics-module--closeButton--2160a";
export var heading = "analytics-module--heading--0ddbc";
export var modal = "analytics-module--modal--dfb53";
export var modalHeading = "analytics-module--modalHeading--c461e";
export var modalImage = "analytics-module--modalImage--e2afd";
export var modalTitle = "analytics-module--modalTitle--74f18";
export var nexArrow = "analytics-module--nexArrow--60c4b";
export var next = "analytics-module--next--edaaa";
export var nextArrow = "analytics-module--nextArrow--831af";
export var noTryItOut = "analytics-module--noTryItOut--c96ca";
export var overlay = "analytics-module--overlay--6b2f0";
export var personalizationSection = "analytics-module--personalizationSection--da3b3";
export var personalizationSectionVertical = "analytics-module--personalizationSectionVertical--349c6";
export var prevArrow = "analytics-module--prevArrow--74c23";
export var previous = "analytics-module--previous--b84c4";
export var previousArrow = "analytics-module--previousArrow--71bce";
export var previousNext = "analytics-module--previousNext--ed0c8";
export var previousNextContainer = "analytics-module--previousNextContainer--cd6fa";
export var previousNextContainerVertical = "analytics-module--previousNextContainerVertical--fb1e3";
export var previousNextVertical = "analytics-module--previousNextVertical--f6a85";
export var similarVideos = "analytics-module--similarVideos--d622f";
export var similarVideosContainer = "analytics-module--similarVideosContainer--f89db";
export var similarVideosHeading = "analytics-module--similarVideosHeading--83e06";
export var tagsContent = "analytics-module--tagsContent--1234a";
export var tagsHeading = "analytics-module--tagsHeading--ff3de";
export var tagsUsed = "analytics-module--tagsUsed--6867e";
export var tagsUsedVertical = "analytics-module--tagsUsedVertical--41004";
export var verticalNoDiyAnalytics = "analytics-module--verticalNoDiyAnalytics--3c8cc";
export var videoContainer = "analytics-module--videoContainer--8f9f1";
export var videoContainerVertical = "analytics-module--videoContainerVertical--6ac37";